import { render, staticRenderFns } from "./AppNavbarHeaderLayoutBrand.vue?vue&type=template&id=a5e2ec5e&"
import script from "./AppNavbarHeaderLayoutBrand.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHeaderLayoutBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports